import React from "react";
import PropTypes from "prop-types";
import { css } from "react-emotion";

const propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }),
  form: PropTypes.shape({
    touched: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
  }),
  autoComplete: PropTypes.oneOf(["off", "on"]),
  type: PropTypes.oneOf(["text", "number", "password", "email", "phone", "textarea"]),
  label: PropTypes.string,
  hideError: PropTypes.bool,
};

function isDefined(val) {
  if (typeof val === "number") return !isNaN(val);
  return val !== undefined && val !== null && val !== "";
}

const CustomInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  autoComplete = "off",
  hideError,
  ...rest
}) => {
  const invalid = touched[field.name] && errors[field.name];
  const invalidClass = invalid ? "invalid" : "";
  const notEmpty = isDefined(field.value);
  const Tag = type === "textarea" ? "textarea" : "input";

  return (
    <div className={`${wrapperClass} ${invalidClass}`}>
      <div className={`${labelClass} ${notEmpty ? activeLabel : ""}`}>{label && label}</div>
      <Tag
        type={type}
        autoComplete={autoComplete}
        {...field}
        {...rest}
        placeholder=""
        style={inputStyle}
      />
      {hideError !== true && <div className={errorClass}>{invalid && errors[field.name]}</div>}
    </div>
  );
};

CustomInput.propTypes = propTypes;
export default CustomInput;

const inputStyle = { marginBottom: 0, opacity: 0.5, background: "#f0f0f0", color: "#000" };

const labelClass = css`
  position: absolute;
  top: 8px;
  left: 11px;
  font-weight: 600;
  font-size: 16px;
  font-family: "Barlow Semi Condensed", sans-serif;
  color: #3e3d3d;
  z-index: 0;
  transition: all 0.35s ease-in-out;
`;

const activeLabel = css`
  top: -20px;
  font-size: 12px;
  color: #6f6f6f6;
`;

const wrapperClass = css`
  position: relative;
`;

const errorClass = css`
  font-size: 12px;
  font-weight: 600;
  color: #fc3666;
  margin-left: 10px;
  margin-top: 0;
  margin-bottom: 3px;
  min-height: 31px;
`;



// WEBPACK FOOTER //
// ./src/components/form/CustomInput.jsx